<template>
    <div class="container mx-auto page no-top-bar">
        <TopBarDetail
            :title="'ติดต่อเรา'"
            :isShowBack="true"
            :isShowFavorite="false"
            :isShowShare="false"
            @clickBack="clickBack()"
        ></TopBarDetail>
        <div class="bg-white px-4 text-gray-1">
            <div class="flex pt-4">
                <img class="my-auto mr-2" src="@/assets/icon/ic-ct-contactus.svg" alt=""/>
                <div class="text-20 text-blue-1 my-auto">ติดต่อเรา</div>
            </div>
            <div class="px-2 border-b border-gray-2 pb-4 text-20">
                <div class="flex pt-4">
                    <img class="my-auto mr-2 w-6" src="@/assets/icon/ic-ct-address.svg" alt=""/>
                    <div class=" text-blue-1 my-auto">• ที่อยู่ที่ติดต่อ</div>
                </div>
                <div class="pl-8">
                    315, อาคารไทยกรุ๊ป ถนนสีลม แขวงสีลม เขตบางรัก กรุงเทพมหานคร 10500
                </div>
            </div>
            <div class="px-2 border-b border-gray-2 pb-4 text-20">
                <div class="flex pt-4">
                    <img class="my-auto mr-2 w-6" src="@/assets/icon/ic-ct-call.svg" alt=""/>
                    <div class="text-blue-1 my-auto">• โทรศัพท์</div>
                </div>
                <div class="pl-8">
                    ศูนย์ดูแลลูกค้า โทร.<a class="text-green-1" href="tel:022555656" >0 2255 5656</a> เปิดบริการวันจันทร์ – วันศุกร์ เวลา 08.30 -17.00 น.
                </div>
            </div>
            <div class="px-2 border-b border-gray-2 pb-4 text-20">
                <div class="flex pt-4">
                    <img class="my-auto mr-2 w-6" src="@/assets/icon/ic-ct-mail.svg" alt=""/>
                    <div class="text-blue-1 my-auto">• อีเมล</div>
                </div>
                <div class="pl-8">
                    <div><a class="text-green-1" href="mailto:splus@tgh.co.th" >splus@tgh.co.th</a></div>

                </div>
            </div>
            <div class="px-2 border-b border-gray-2 pb-4 text-20">
                <div class="flex pt-4">
                    <img class="my-auto mr-2 w-6" src="@/assets/icon/ic-ct-map.svg" alt=""/>
                    <div class="text-blue-1 my-auto">• Map</div>
                </div>
                <div class="pl-8 text-green-1" @click="clickMap()">
                    คลิกดูแผนที่
                </div>
            </div>
            <div class="px-2 border-b border-gray-2 pb-4 text-20">
                <div class="flex pt-4">
                    <img class="my-auto mr-2 w-6" src="@/assets/icon/ic-ct-helpchat.svg" alt=""/>
                    <div class=" text-blue-1 my-auto">• Help Chat</div>
                </div>
                <div class="pl-8">
                    สอบถามออนไลน์ได้วันจันทร์ - ศุกร์<br />
                    เวลา 08.30 - 17.00 น.
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import ConfigManager from "@/config/ConfigManager.js";
import TopBarDetail from '@/components/Layout/TopBar/TopBarDetail.vue';

export default {
    name: 'Contactus',
    components: {
        TopBarDetail,
    },
    created: function() {
        this.tracking.screenName('contact_us');
        this.tracking.event('contact_us', 'view_contact_us');
    },
    methods: {
        clickBack: function() {
            this.$router.back();
        },
        clickMap: function() {
            window.location.href = "https://goo.gl/maps/EzWeB4oNweG2";
        },
        urlcontactus: function() {
            return ConfigManager.getMiscUrl() + '/seg/contactus.html';
        }
    },
}
</script>
